import React from 'react';
//import './App.css';
import AppRoutes from "./routes.js";
import Navbar from "./layouts/navbar.jsx";
import Footer from "./layouts/footer.jsx";
const App = () => {
  return (
    <div>
      <Navbar />
      <AppRoutes />
      <Footer/>
    </div>
  );
};

export default App;
